import React from "react"
import MetaTags from "react-meta-tags"
import PropTypes from 'prop-types'

const PageMetaTags = props => {
  const { title } = props

  return (
    <MetaTags>
      <title>{title} | enCappture Admin</title>
    </MetaTags>
  )
}

PageMetaTags.propTypes = {
  title: PropTypes.string
}

export default PageMetaTags
